import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Transactions } from '@app/_models';
import { ApiBackendService } from '@app/_services/api-backend.service';
import { environment } from 'src/environments/environment';
import { throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})
export class ThankYouComponent implements OnInit {

  orderId: string;
  transaction: Transactions;
  currentUserInfo = null;

  constructor(
    private route: ActivatedRoute,
    public apiBackendService: ApiBackendService,
    private httpClient: HttpClient,
    private router: Router,
  ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);

    this.currentUserInfo = JSON.parse(localStorage.getItem('currentUser'));

    this.route.queryParams.subscribe((params) => {
      this.orderId = params.order_id;
      console.log('p', params);
      console.log(this.orderId);
      this.apiBackendService
        .getTransactionByOrderId(this.orderId)
        .pipe()
        .subscribe((res) => {
          console.log(res.body);
          this.transaction = res.body;
          if (this.orderId != undefined) {
            setTimeout(() => {
              this.router.navigate(['/upload']);
            }, 5000);
          }
        });
    });

  }

}
